module.exports = __webpack_public_path__ + "img/Opened.af53eed8.svg";